import React, { FC } from 'react'
import { IconicCompaniesProps } from './IconicCompanies.types'
import { sanitizeHTML } from '@ampdx/common-utils/src'
import './IconicCompanies.scss'

export const IconicCompanies: FC<IconicCompaniesProps> = props => {
  const {
    bgImage,
    timeImage,
    timeAltText,
    iconicContent,
    rateImage,
    rateAltText,
    rateContent,
    forbesImage,
    forbesAltText,
    linkText,
    linkDisclosure,
  } = props.content

  const scrollToSection = (path: string) => {
    const section = document.getElementById(path)
    console.log('section', section)
    section?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <>
      <style
        type='text/css'
        dangerouslySetInnerHTML={{
          __html: `
        .IconicCompanies--Page { background: url("${bgImage}");
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        box-sizing: border-box; }
      `,
        }}
      />
      <section className='IconicCompanies--Page'>
        <div className='u-sizeConstrained'>
          <div className='IconicCompanies--overlay '>
            <div className='IconicCompanies--overlayContent u-flex u-sm-flexCol u-md-flexCol u-flexAlignItmesCenter'>
              <div className='IconicCompanies--TimeImage'>
                <img src={timeImage} alt={timeAltText} />
              </div>
              <div
                className='IconicCompanies--iconicContent u-md-padding20 u-sm-padding20'
                dangerouslySetInnerHTML={{ __html: sanitizeHTML(iconicContent) }}></div>
            </div>
          </div>
          <div className='IconicCompanies--bottomContent u-flex u-md-flexColReverse u-sm-flexColReverse'>
            <div className='IconicCompanies--starContnet u-flex u-flexCol u-sm-paddingTop48 u-md-paddingTop48'>
              <div className='IconicCompanies--starImage'>
                <img src={rateImage} alt={rateAltText} />
              </div>
              <div
                className='IconicCompanies--rateContent'
                dangerouslySetInnerHTML={{ __html: sanitizeHTML(rateContent) }}></div>
            </div>
            <div>
              <div className='IconicCompanies--forbesImage'>
                <img src={forbesImage} alt={forbesAltText} />
              </div>
            </div>
          </div>
          <div className='Disclaimer-text u-paddingTop80 u-flex u-flexJustifyEnd u-paddingRight48'>
            <a
              className='IconicCompanies--disclosureLink'
              href={'#' + linkDisclosure}
              onClick={e => {
                e.preventDefault()
                scrollToSection(linkDisclosure)
              }}>
              {linkText}
            </a>
          </div>
        </div>
      </section>
    </>
  )
}
